import React from 'react';

import { useHistory } from 'react-router';

import { employeeGroupsRoute } from '../../../web-routes';
import { MessageThreadHeader } from '../message-thread-header';

import { EmployeeGroupAnnouncements } from './employee-group-announcements';

import { ICON_NAMES, MaterialDesignIcon } from '../../../util/material-design-icons';

type InputProps = {
  orgId: number;
  employeeGroup: EmployeeGroup | EmployeeGroupWithAllOption;
  groupMembershipCounts: { [employeeGroupId: string | number]: number };
  onClose: () => void;
};

export const EmployeeGroupThread = (props: InputProps) => {
  const { orgId, employeeGroup, groupMembershipCounts, onClose } = props;

  const history = useHistory();

  const handleRouteToEmployeeGroup = () => {
    history.push(employeeGroupsRoute(orgId));
  };

  const groupMemberCount = groupMembershipCounts[employeeGroup.employeeGroupId] || 0;

  return (
    <>
      <MessageThreadHeader
        recipientName={employeeGroup.name}
        onClose={onClose}
        handleRecipientNameClick={handleRouteToEmployeeGroup}
        sublabel={`${groupMemberCount} employee${groupMemberCount === 1 ? '' : 's'}`}
        HeaderAction={{
          name: 'Manage Groups',
          handler: handleRouteToEmployeeGroup,
          Icon: (
            <MaterialDesignIcon
              className="u-margin-right"
              size="xs"
              iconName={ICON_NAMES.EXIT_TO_APP}
            />
          ),
        }}
      />
      <div className="u-overflowY-auto u-border-top u-height-100 u-position-relative u-padding-2x">
        <div className="u-maxWidth-800px u-margin-0Auto">
          <EmployeeGroupAnnouncements
            orgId={orgId}
            employeeGroupId={employeeGroup.employeeGroupId}
            onClose={onClose}
          />
        </div>
      </div>
    </>
  );
};
